
import { Link } from "react-router-dom";
import { OptimizedImage } from "@/components/ui/image";

type BlogPostCardProps = {
  id: string;
  title: string;
  excerpt: string;
  image_url: string | null;
  category: string;
  text_direction?: "ltr" | "rtl";
}

export function OptimizedBlogPostCard({
  id,
  title,
  image_url,
  text_direction = "ltr",
}: BlogPostCardProps) {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-sm">
      <div className="w-full">
        <OptimizedImage 
          src={image_url || "https://images.unsplash.com/photo-1581472723648-909f4851d4ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"} 
          alt={`Blog post: ${title}`} 
          width={384}
          height={192}
          className="w-full h-48 object-cover"
          aria-label={`Featured image for blog post: ${title}`}
        />
      </div>
      <div className="p-6" dir={text_direction}>
        <h3 className={`text-xl font-semibold mb-4 ${text_direction === "rtl" ? "text-right" : ""}`}>
          {title}
        </h3>
        <div className={`${text_direction === "rtl" ? "text-right" : ""}`}>
          <Link 
            to={`/blog/${id}`} 
            className="text-[#34BC56] font-medium hover:underline"
            aria-label={text_direction === "rtl" ? `اقرأ المزيد عن ${title}` : `Read More about ${title}`}
          >
            {text_direction === "rtl" ? "اقرأ المزيد" : "Read More"}
          </Link>
        </div>
      </div>
    </div>
  );
}
